// extracted by mini-css-extract-plugin
export var compactFilters = "_iw-4";
export var detailImage = "_iw-1";
export var dropdownContainer = "_iw-2";
export var imageContainer = "_iw-0";
export var selectedCard = "_iw-3";